import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateGradeScaleMutation = graphql.persisted(
  "UpdateGradeScale",
  graphql(`
    mutation UpdateGradeScale($input: UpdateGradeScaleInput!) {
      updateGradeScale(input: $input) {
        school {
          id
          gradeScaleSetting {
            entries {
              letter
              minimumPercentage
              gpaPoints
              color
            }
          }
        }
        userErrors { message path }
      }
    }
  `)
);

export { UpdateGradeScaleMutation };

export function useUpdateGradeScale() {
  return useMutation(UpdateGradeScaleMutation);
}
